module.exports = __webpack_public_path__ + "static/img/zhuanli-2.367e76f5.png";